<script lang="ts">
  import { stopPropagation } from "./genericHandlers";
  import settingsGearIcon from "./assets/settings.svg?raw";
  import { GuidedSceneSettingDescriptions } from "./GuidedSceneSettings";
  import { SettingDescription, type SettingId } from "./lib/Settings";

  import Modal from "./Modal.svelte";
  import BooleanSettingToggle from "./settings/BooleanSettingToggle.svelte";

  export let scene;
  export let settingsChangedCallback: (setting: SettingId, newVal: any) => void;

  let showModal = false;
  let saving = false;

  type sceneSetting<T> = {
    id: SettingId;
    description: SettingDescription<T>;
    value: T;
  };

  function settingFromDescription<T>(
    description: SettingDescription<T>,
  ): sceneSetting<T> {
    return {
      id: description.id,
      description: description,
      value: scene.settings.getValue(description.id),
    };
  }

  let settingDescriptions = [
    settingFromDescription(GuidedSceneSettingDescriptions.IsMusicAPlaylist),
    settingFromDescription(
      GuidedSceneSettingDescriptions.MusicCrossfadeEnabled,
    ),
    settingFromDescription(
      GuidedSceneSettingDescriptions.StartMusicWhenStartingScene,
    ),
    settingFromDescription(
      GuidedSceneSettingDescriptions.AdvancedAmbienceLoopControls,
    ),
  ];

  function updateSetting(setting, val) {
    saving = true;
    settingsChangedCallback(setting, val);
    saving = false;
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="control-button"
  on:click={() => {
    showModal = true;
  }}
  on:pointerdown={stopPropagation}
  on:mousedown={stopPropagation}
>
  {@html settingsGearIcon}
</div>
<Modal bind:showModal>
  <p slot="header">Settings for scene: {scene.name}</p>
  <div class="guided-scene-settings-modal">
    {#each settingDescriptions as setting (setting.id)}
      <BooleanSettingToggle
        value={setting.value}
        description={setting.description}
        {updateSetting}
      />
    {/each}
  </div>
  <div slot="footer">
    <div class="center-contents-h container">
      {#if saving}
        <button
          class="contrast outline"
          aria-busy="true"
          on:click={stopPropagation}
          on:pointerdown={stopPropagation}
          on:mousedown={stopPropagation}>Saving...</button
        >
      {:else}
        <button
          class="contrast outline"
          on:click={() => {
            showModal = false;
          }}>Close</button
        >
      {/if}
    </div>
  </div>
</Modal>
